export enum SurfaceUnitEnum {
  SQM = 'SQM',
  SQFT = 'SQFT',
}

export type SurfaceUnit = SurfaceUnitEnum.SQM | SurfaceUnitEnum.SQFT;
